<template>
  <section hidden="true">
    <h2>Career Goals</h2>
    <p>Outline your future aspirations and what you aim to achieve in your career.</p>
    <p>Discuss areas you want to grow in or industries you're interested in.</p>
  </section>
</template>

<script>
export default {
  name: 'CareerGoalsSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>